import SparkMD5 from 'spark-md5';

/**
 * Create a unique numeric hash for a string.  This is only used to tell if content has
 * changed, not to create a secure hash!
 *
 * @param {string} str
 * @returns {string}
 */
export function md5hash(str: string): string {
    const spark = new SparkMD5();
    spark.append(str);
    return spark.end();
}